export enum CompanyVerificationRequestStatus {
  Approved = 'approved',
  FormSubmitted = 'form_submitted',
  Pending = 'pending',
  Rejected = 'rejected',
}
